import type { LoyaltyCouponSeriesFormState, LoyaltyCouponSeriesTranslation } from '@@partner:types:app'

export function makeLoyaltyCouponSeriesFormState (): LoyaltyCouponSeriesFormState {
  return {
    id: undefined,
    code: '',
    title: '',
    description: '',
    image_file_id: undefined,
    validFrom: undefined,
    validUntil: undefined,
    i18n: [],
    canBeActivated: true
  }
}

export function mapApiDataToState (apiData?: any): Partial<LoyaltyCouponSeriesFormState> {
  if (!apiData) return {}

  return {
    id: apiData.id,
    code: apiData.code || '',
    title: apiData.title || '',
    description: apiData.description || '',
    image_file_id: apiData.image_file_id,
    validFrom: apiData.validFrom ? new Date(parseInt(apiData.validFrom)) : undefined,
    validUntil: apiData.validUntil ? new Date(parseInt(apiData.validUntil)) : undefined,
    i18n: apiData.i18n || [],

    canBeActivated: apiData.canBeActivated
  }
}

export function mapStateToApiVariable (state: LoyaltyCouponSeriesFormState) {
  // Убираем id из переводов для GraphQL input
  const i18nForApi = state.i18n.length > 0 
    ? state.i18n.map(({ language_code, title, description }) => ({
      language_code,
      title,
      description
    }))
    : undefined

  const baseData = {
    code: state.code,
    title: state.title,
    description: state.description || undefined,
    image_file_id: state.image_file_id || undefined,
    validFrom: state.validFrom ? state.validFrom.getTime() : null,
    validUntil: state.validUntil ? state.validUntil.getTime() : null,
    i18n: i18nForApi,
    
    canBeActivated: state.canBeActivated
  }

  if (state.id) {
    return {
      id: state.id,
      input: baseData
    }
  }

  return {
    input: baseData
  }
}
